document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Sticky header background on scroll ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var toggleHeader = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    toggleHeader();
    window.addEventListener('scroll', toggleHeader, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Hero parallax ---------- */
  var parallax = document.querySelector('[data-parallax-img]');
  if (parallax && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', function () {
      var offset = window.scrollY * 0.25;
      parallax.style.transform = 'translateY(' + offset + 'px)';
    }, { passive: true });
  }

  /* ---------- Search overlay ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchOpenBtns = document.querySelectorAll('[data-search-open]');
  var searchCloseBtns = document.querySelectorAll('[data-search-close]');
  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      searchOverlay.classList.add('is-open');
      var input = searchOverlay.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 150);
    });
  });
  searchCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { searchOverlay.classList.remove('is-open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay) searchOverlay.classList.remove('is-open');
  });

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileOpenBtns = document.querySelectorAll('[data-mobile-menu-open]');
  var mobileCloseBtns = document.querySelectorAll('[data-mobile-menu-close]');
  mobileOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu.classList.add('is-open'); });
  });
  mobileCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { mobileMenu.classList.remove('is-open'); });
  });

  /* ---------- Cart drawer (AJAX) ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function renderCartDrawer(cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p>Your bag is empty.</p><a href="/collections/all" class="btn btn--gold">Continue Shopping</a>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-drawer__item" style="display:flex;gap:1rem;margin-bottom:1.2rem;">' +
        (item.image ? '<img src="' + item.image + '" alt="" style="width:64px;height:80px;object-fit:cover;border-radius:3px;">' : '') +
        '<div><p style="margin:0 0 .3rem;font-size:.9rem;">' + item.product_title + '</p>' +
        '<p style="margin:0;font-size:.8rem;color:#777;">Qty ' + item.quantity + ' &middot; ' + (item.line_price / 100).toFixed(2) + '</p></div></div>';
    });
    html += '<a href="/cart" class="btn btn--outline" style="width:100%;margin-bottom:.75rem;">View Bag</a>';
    html += '<a href="/checkout" class="btn btn--gold" style="width:100%;">Checkout</a>';
    body.innerHTML = html;
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer).catch(function () {});
  }

  cartOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartDrawer) {
        e.preventDefault();
        fetchCart();
        cartDrawer.classList.add('is-open');
      }
    });
  });
  cartCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { cartDrawer.classList.remove('is-open'); });
  });

  /* Intercept product-card / product-page add-to-cart forms for AJAX add */
  document.querySelectorAll('.product-card__form, .product-page__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var countEl = document.querySelector('.site-header__cart-count');
            if (countEl) countEl.textContent = cart.item_count;
            renderCartDrawer(cart);
            if (cartDrawer) cartDrawer.classList.add('is-open');
          });
        })
        .catch(function () { form.submit(); });
    });
  });

  /* ---------- Wishlist (local storage, front-end only) ---------- */
  document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = val;
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- Product page thumbnail swap ---------- */
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) mainImg.src = thumb.getAttribute('data-thumb-src');
    });
  });

  /* ---------- New arrivals slider ---------- */
  var track = document.querySelector('[data-slider-track]');
  if (track) {
    var prevBtn = document.querySelector('[data-slider-prev]');
    var nextBtn = document.querySelector('[data-slider-next]');
    var index = 0;

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 640) return 1;
      if (w <= 1024) return 2;
      return 4;
    }

    function update() {
      var items = track.children;
      if (!items.length) return;
      var itemWidth = items[0].getBoundingClientRect().width + 32; // gap
      var maxIndex = Math.max(0, items.length - getVisibleCount());
      index = Math.min(index, maxIndex);
      track.style.transform = 'translateX(-' + (index * itemWidth) + 'px)';
    }

    if (nextBtn) nextBtn.addEventListener('click', function () {
      var items = track.children;
      var maxIndex = Math.max(0, items.length - getVisibleCount());
      index = Math.min(index + 1, maxIndex);
      update();
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      index = Math.max(index - 1, 0);
      update();
    });
    window.addEventListener('resize', update);
  }

});
